
//系统目录 / 药品剂型 接口相关的函数
import request from "../../untils/request.js"

/**
 *
 *  post
 *
 */

//坐诊列表
export const getClinicScheduleData = (params) => {
    return request.get("/outpatient/drgstable/page", {params} )
}

//科室列表
export const getAttribute = (data) => {
    return request.get("/outpatient/findAttribute", data )
}

//医生列表
export const getActiveList = (params) => {
    return request.get("/outpatient/selectDeptStaff", {params} )
}

//挂号类型列表
export const getCategory = (params) => {
    return request.get("/outpatient/registertype/list", {params} )
}

//坐诊添加
export const addClinicSchedule= (data) => {
    return request.post("/outpatient/drgstable", data)
}

//坐诊修改
export const editClinicSchedule= (data) => {
    return request.put("/outpatient/drgstable", data)
}

//修改状态
export const editState= (params) => {
    return request.get("/outpatient/drgstable/updateState", {params})
}

//根据坐诊ID查询对应挂号费别
export const getCategoryById= (params) => {
    return request.get("/outpatient/drgstable/get", {params})
}

//员工列表
export const getStaffList= (data) => {
    return request.get("/outpatient/list",data )
}

export default{
    getClinicScheduleData,getAttribute,getActiveList,getCategory,getCategoryById
}